import { useSuspenseQuery } from "@tanstack/react-query";
import type { FeatureFlagNames } from "shared";
import { Api } from "../api.config";
import { QueryKeys } from "../LinkGen";

function useAppMetadata() {
	return useSuspenseQuery({
		queryKey: QueryKeys.AppMetadata(),
		queryFn: () => Api.GetAppMetadata().then((x) => x.data),
	});
}

export function useFeatureFlag(name: FeatureFlagNames) {
	const { data } = useAppMetadata();

	return data.featureFlags[name] ?? false;
}

export function useBranding() {
	const { data } = useAppMetadata();

	return data.branding;
}
